import { useEventListener } from '@anton.bobrov/react-hooks';

function useFormSelectExpandNavigation({
  ref,
  listboxElement,
  isActive,
  onActive
}) {
  useEventListener({
    ref,
    target: "keydown",
    listener: (event) => {
      if (event.key === "ArrowDown") {
        event.preventDefault();
        onActive(true);
      }
    },
    isDisabled: isActive
  });
  useEventListener({
    ref,
    target: "keydown",
    listener: (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        onActive(false);
      }
    },
    isDisabled: !isActive
  });
  useEventListener({
    ref: listboxElement,
    target: "click",
    listener: () => {
      const button = ref.current?.querySelector("button");
      button?.focus();
    },
    isDisabled: !isActive
  });
}

export { useFormSelectExpandNavigation };
//# sourceMappingURL=useFormSelectExpandNavigation.js.map
